// extracted by mini-css-extract-plugin
export default {"playerContainerVertical":"playerContainerVertical__0cHZd","playerContainer":"playerContainer__XdKby"};